<div class="flex items-center gap-4 pl-2">
    <mat-icon [fontIcon]="data?.icon || 'mdi-information'" fontSet="mdi"></mat-icon>

    <div class="flex flex-col p-1">
        <span class="font-bold text-lg"> {{ data?.title || 'Message'}} </span>
        <div>{{ data.message }}</div>
    </div>

    <button matButton (click)="onAction()">{{ data?.actionLabel || 'OK' }}</button>
</div>
